import * as YAML from 'yaml';

import { CodeLanguageType } from '@/components/Code/types';

/**
 * Helper function to format and truncate content based on language preference
 * @param value - The value to format (can be any type)
 * @param language - The code language type ('json' or 'yaml')
 * @param maxLength - Maximum length before truncation
 * @returns Formatted and potentially truncated string
 */
export const formatContent = (
  value: any,
  language: CodeLanguageType,
  maxLength: number
): string => {
  try {
    let formattedString: string;
    if (typeof value === 'string') {
      formattedString = value;
    } else if (value === null || value === undefined) {
      formattedString = String(value);
    } else {
      // Format according to requested language, with string fallback
      if (language === 'yaml') {
        try {
          formattedString = YAML.stringify(value);
        } catch (yamlError) {
          formattedString = String(value);
        }
      } else {
        formattedString = JSON.stringify(value, null, 2);
      }
    }
    return formattedString.length > maxLength
      ? formattedString.slice(0, maxLength) + '...'
      : formattedString;
  } catch (error) {
    // Ultimate fallback - ensure we always return something displayable
    return value?.toString?.() || '[Unparseable Object]';
  }
};
